module.exports = __webpack_public_path__ + "img/uploadYes.0d95637a.svg";